import api from '@/api';

const { $pricing, $commission } = api;

export const { $types, $products } = $pricing;
export const { $commissions } = $commission;